module.exports = __webpack_public_path__ + "media/src/img/insta-icon-bf37b933d10ce1b1baa9fa1832bff260.svg";